import config from "@/config";
import { useRouter } from "@tanstack/react-router";
import { useAppDispatch } from "@/redux/hooks";
import { setVerified } from "@/redux/slices/VerifySlice";
import {useLogout} from '@privy-io/react-auth';
import { removeCookie } from "typescript-cookie";

// Custom hook for navigation utilities
export function useNavigationUtils() {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const {logout} = useLogout({
    onSuccess: () => {
      router.navigate({
        to: config.PATHNAME.HOME,
      });
    },
  });

  const handleLogout = () => {
    logout();
    dispatch(setVerified(false));
    localStorage.clear();
    sessionStorage.clear();
    removeCookie("accessToken");
    router.navigate({
      to: config.PATHNAME.HOME,
    });
  };

  const handlePath = (path: string) => {
    router.navigate({ to: path });
  };

  return {
    handleLogout,
    handlePath
  };
}